import React from 'react'
import { webinarLinkTo } from 'event-taxonomy'
import css from './style.scss'

const WEBINARS_PER_SECTION_LIMIT = 10

export class CuratedWebinarSection extends React.Component {
  constructor (props) {
    super(props)
    const openSections = (props.sections || []).reduce((acc, _, i) => {
      acc[i] = false
      return acc
    }, {})
    this.state = {
      webinarsBySection: {},
      openSections,
      expandedSections: {}
    }
    this.toggleSection = this.toggleSection.bind(this)
    this.expandSection = this.expandSection.bind(this)
  }

  buildFilterUrl (condition) {
    // eslint-disable-next-line no-undef
    const base = `${CONFIG.apiUrl}/v2/webinars?filters[past]=true`
    const params = []
    if (condition.category_id) {
      params.push(`filters[category_id]=${encodeURIComponent(condition.category_id)}`)
    }
    if (condition.tags && condition.tags.length > 0) {
      condition.tags.forEach(tag => params.push(`filters[tags][]=${encodeURIComponent(tag)}`))
    }
    return params.length > 0 ? `${base}&${params.join('&')}` : null
  }

  componentDidMount () {
    const { sections = [] } = this.props
    sections.forEach((section, index) => {
      // Normalise to a conditions array; fall back to legacy category_id field
      const conditions = section.conditions && section.conditions.length > 0
        ? section.conditions
        : section.category_id ? [{ category_id: section.category_id }] : []

      if (conditions.length === 0) return

      const fetches = conditions
        .map(c => this.buildFilterUrl(c))
        .filter(Boolean)
        // eslint-disable-next-line no-undef
        .map(url => fetch(url).then(res => res.json()).catch(() => []))

      Promise.all(fetches).then(results => {
        // OR: union all results, deduplicate by webinar id
        const seen = new Set()
        const webinars = []
        results.forEach(list => {
          if (!Array.isArray(list)) return
          list.forEach(w => {
            if (!seen.has(w.id)) {
              seen.add(w.id)
              webinars.push(w)
            }
          })
        })
        this.setState(prev => ({
          webinarsBySection: { ...prev.webinarsBySection, [index]: webinars }
        }))
      })
    })
  }

  toggleSection (index) {
    this.setState(prev => ({
      openSections: { ...prev.openSections, [index]: !prev.openSections[index] }
    }))
  }

  expandSection (index) {
    this.setState(prev => ({
      expandedSections: { ...prev.expandedSections, [index]: true }
    }))
  }

  render () {
    const { header, subheader, sections = [], textColor, linkColor } = this.props
    const { webinarsBySection, openSections, expandedSections } = this.state
    const titleStyle = textColor ? { color: textColor } : {}
    const linkStyle = linkColor ? { color: linkColor } : {}

    return (
      <div className={css.curatedSection}>
        {header && <h2 className={css.curatedSectionTitle} style={titleStyle}>{header}</h2>}
        {subheader && <p className={css.curatedSectionSubtitle}>{subheader}</p>}
        {sections.map((section, index) => {
          const webinars = webinarsBySection[index] || []
          const isOpen = !!openSections[index]
          const isExpanded = !!expandedSections[index]
          const visibleWebinars = isExpanded ? webinars : webinars.slice(0, WEBINARS_PER_SECTION_LIMIT)
          const hasMore = webinars.length > WEBINARS_PER_SECTION_LIMIT && !isExpanded

          return (
            <div key={index} className={css.roleGroup}>
              <h3 className={css.roleGroupTitle}>
                <button
                  type='button'
                  className={css.roleGroupHeader}
                  aria-expanded={isOpen}
                  onClick={() => this.toggleSection(index)}
                >
                  <span>{section.title}</span>
                  <span className={css.roleGroupToggle} aria-hidden='true'>{isOpen ? '−' : '+'}</span>
                </button>
              </h3>
              {isOpen && (
                <ul className={css.webinarList}>
                  {visibleWebinars.length > 0
                    ? visibleWebinars.map(webinar => (
                      <li key={webinar.id} className={css.webinarListItem}>
                        <a href={webinarLinkTo(webinar)} className={css.webinarLink} style={linkStyle} target='_blank' rel='noopener noreferrer'>
                          {webinar.title}
                        </a>
                      </li>
                      ))
                    : (section.conditions || section.category_id) && <li className={css.loadingState}>Loading…</li>}
                </ul>
              )}
              {isOpen && hasMore && (
                <button
                  type='button'
                  className={css.viewMoreButton}
                  onClick={() => this.expandSection(index)}
                >
                  View More
                </button>
              )}
            </div>
          )
        })}
      </div>
    )
  }
}
